import React, {Fragment} from "react";
import PropTypes, { element } from "prop-types";
import { RadialBarChart, PieChart as RechartPieChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Pie, Cell } from "recharts";
import { ChartLoader } from "../DataChart";

export default class PieChart extends React.Component {

    static propTypes = {
        // the fieldname used as the base of grouping (the "X axis label")
        base: PropTypes.string,
        // an array containing the dataKey for the pies' value
        visibleData: PropTypes.array,
        // an object containing a realHeight (number) and realWidth (number)
        activeDimensions: PropTypes.object
    }

    render() {
        const chartWidth = this.props.activeDimensions?.realWidth || 300 + (this.props.visibleData.length - 1) * 40;
        const dataField = this.props.visibleData[0];

        if (this.props.visibleData.length > 1) {
            return <div className="data-chart-error">
                Hiba a widget beállításaiban: több, mint egy adat.
            </div>;
        }

        return this.props.value.length == 0 ? <ChartLoader /> :
            <RechartPieChart 
                width={chartWidth}
                height={this.props.activeDimensions?.realHeight ? this.props.activeDimensions.realHeight - 45 : 260}
                data={this.props.value}>
                {/* <Tooltip 
                    formatter={(value, name, index) => [
                        this.props.columnSettings[name]?.renderer(value) || value,
                        this.props.possibleVisibleColumns.find(col => col.value == name)?.label || name
                    ]}
                /> */}
                <Legend
                    formatter={(value, entry, index) => this.props.possibleVisibleColumns.find(col => col.value == value)?.label || value}
                />
                <Pie
                    data={this.props.value}
                    dataKey={dataField}
                    nameKey={this.props.base}
                    labelLine={false}
                    label={(props) => renderCustomizedLabel({...props, renderer: this.props.columnSettings[dataField]?.renderer})}
                >
                    {this.props.value.map((entry, cellIndex) => (
                        <Cell 
                            key={`cell-${cellIndex}`}
                            fill={this.props.colors[cellIndex]}
                        />
                    ))}
                </Pie>
            </RechartPieChart>;
    }
}

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index, renderer, fill}) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.1;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    let renderedValue = renderer && getNodeText(renderer(value)) || value;

    return (
        <text x={x} y={y} fill={fill} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {renderedValue}
        </text>
    );
};

const getNodeText = node => {
    if (['string', 'number'].includes(typeof node)) {
        return node;
    } else if (node instanceof Array) {
        return node.map(getNodeText).join('');
    } else if (typeof node === 'object' && node) {
        return getNodeText(node.props.children);
    }
  }